//process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
import { ResponseMapper, ResponseMapperImpl } from "./response/responsemapper";
import { Logger, LogManager } from "../logger/logger";
import * as https from 'https';
import { BaseContext } from '../basecontext';
import { Strings } from '../resources/strings';
//import { AxiosError } from 'axios'


let axios = require('axios');
export interface HttpClientCredendtial
{
    getBASEURL(): string;
    getHttpMethod(): string;
    getQueryParams(): string;
    getHttpHeaders(): string;
}

export interface HttpClient
{
   createRequest(context: BaseContext, request: any, httpClientCredential: HttpClientCredendtial): HttpClient;
   setHttpClientHandler(HttpClientHandler: HttpClientHandler): void;
   execute(): void;
}

export interface HttpClientHandler
{
    onSuccess(responseMapper: ResponseMapper): void;
    onFailure(responseMapper: ResponseMapper): void;
    onUploadProgress(percentage: number): void;
}

export class HttpClientImpl implements HttpClient
{
    private logger: Logger = LogManager.getLogger(HttpClientImpl.name);
    private httpRequest: any;
    private context: BaseContext;

    private httpClientHandler: HttpClientHandler;

    constructor()
    {
        this.logger.log("HttpClientImpl() invoked");
    }

    setHttpClientHandler(httpClientHandler: HttpClientHandler): void 
    {
       
        this.httpClientHandler = httpClientHandler;
    }

    createRequest(context: BaseContext, request: any, httpClientCredential: HttpClientCredendtial): HttpClient
    {
        this.context = context;
        // let MWUrl = "";
        // if(httpClientCredential.getAPIURL() === "settings")
        // {
        //     MWUrl = "http://localhost:8000/en/app-settings.json";
        // }
        // else if(httpClientCredential.getAPIURL() === "https://callertunes.etisalat.ae/en/en/ENG/faq_iosformat.json")
        // {
        //     MWUrl = "http://localhost:8000/en/en/ENG/faq_iosformat.json";
        // }
        // else
        // {
        //     MWUrl =  httpClientCredential.getAPIURL();
        // }

        this.logger.log("URL: " + httpClientCredential.getBASEURL());
        this.logger.log("Request: " + request);
        this.logger.log("Headers: " + JSON.stringify(httpClientCredential.getHttpHeaders()));
        
        this.httpRequest = axios(
            {
                method: httpClientCredential.getHttpMethod(),  
                headers: httpClientCredential.getHttpHeaders(),
                url: httpClientCredential.getBASEURL(),
                onUploadProgress: (ev: ProgressEvent) => {
                    const progress = ev.loaded / ev.total * 100;
                    this.httpClientHandler.onUploadProgress(Math.round(progress));
                },
                params: httpClientCredential.getQueryParams(),
                data: request,
                crossDomain: true,
                 strictSSL: false,
                httpsAgent: new https.Agent({  
                    rejectUnauthorized: true,
                ca: process.env.REACT_APP_CA_CERT,
                cert: process.env.REACT_APP_CERT,
                key: process.env.REACT_APP_KEY
                })
            }
            );
            
        this.logger.log("httpRequest: " + this.httpRequest);

        return this;
    }

    execute(): void
    {   
        /* let response:any;
        response = "{\"responseMap\":{\"accessToken\":\"1e3a077e-445a-40ac-baf3-f8ee50767bc4\",\"refreshToken\":\"b74628e1-8457-4f2c-9d92-1bed00bbfcd2\",\"expiry\":600000,\"otp\":\"2233\"},\"message\":\"Success\",\"respTime\":\"Apr 8, 2020 12:15:07 PM\",\"statusCode\":\"SC0000\"}";
        this.logger.log("My1 : "+response);
        this.logger.log("My2 : "+response.status);

        let responseMapper = this.getResponseMapper();
            responseMapper.setResponseMap(response);
            responseMapper.setStatusMsg("Success");
            responseMapper.setRespTime("Apr 8, 2020 12:15:07 PM");
            responseMapper.setStatusCode("SC0000");

            this.logger.log("Response: " + responseMapper.getResponseMap());

            this.httpClientHandler.onSuccess(responseMapper);
 */

/* let data = JSON.parse(JSON.stringify(response)).data;
                let responseMapper = new ResponseMapperImpl();
                responseMapper.setResponseMap(data.responseMap);
                responseMapper.setStatusCode(data.statusCode);
                responseMapper.setStatusMsg(data.message);
                console.log(responseMapper.getResponseMap());
                console.log(responseMapper.getStatusCode());
                console.log(responseMapper.getStatusMsg());
                console.log(responseMapper.getResponseMap().respDesc); */

         this.httpRequest
        .then((response:any) => 
        {   
            console.log("-----response: " + response);
            
            let data = JSON.parse(JSON.stringify(response)).data;

            let responseMapper = this.getResponseMapper();
            responseMapper.setStatusCodeOutside(data.statusCode);
            responseMapper.setResponseMap(data.responseMap);
            responseMapper.setStatusCode(response.status);
            responseMapper.setStatusMsg(data.message);

            this.logger.log("Response: " + JSON.stringify(responseMapper.getResponseMap()));

            this.httpClientHandler.onSuccess(responseMapper);
        })
        .catch((error:any) => 
        {
            this.logger.error("Error : " + JSON.stringify(error.response));
            this.logger.error("Exception occurred in execute: " + error.message);

            // this.logger.error(error.stack);

            let responseMapper = this.getResponseMapper();

            if(error.response)
            {
                let data = JSON.parse(JSON.stringify(error.response)).data;
                if(data.responseMap !== undefined && data.responseMap !== null &&
                    data.responseMap.respDesc !== undefined && data.responseMap.respDesc !== null)
                    {
                    responseMapper.setStatusMsg(data.responseMap.respDesc);
                }
                else if(data.message !== undefined && data.message !== null)
                {
                    console.log("-----data.message: " + data.message);
                    responseMapper.setStatusMsg(data.message);
                }
                else
                {
                    responseMapper.setStatusMsg(this.context.getResources().getString(Strings.internal_server_error));
                }
                responseMapper.setStatusCode(error.response.status);
                responseMapper.setResponseMap(error.response);
            }
            else
            {
                responseMapper.setStatusCode("-1");
                responseMapper.setStatusMsg(error.message);
            }

            this.httpClientHandler.onFailure(responseMapper);
        });
    }

    protected getResponseMapper(): ResponseMapper
    {
        return new ResponseMapperImpl();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/httpclient/httpclient.tsx